import axios, { AxiosInstance } from 'axios';
import { getStoredToken } from '@/utils/session';
import { categorizeError } from './errors';
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const TENANT_SLUG = import.meta.env.VITE_TENANT_SLUG || '';

let onUnauthorized: (() => void) | null = null;

export const setOnUnauthorized = (fn: (() => void) | null): void => {
  onUnauthorized = fn;
};

export const apiClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Tenant-Slug': TENANT_SLUG,
  },
  timeout: 30000,
});

apiClient.interceptors.request.use(
  config => {
    if (!config.headers['X-Tenant-Slug'] && !config.headers['x-tenant-slug']) {
      config.headers['X-Tenant-Slug'] = TENANT_SLUG;
    }

    const token = getStoredToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

apiClient.interceptors.response.use(
  response => response.data,
  error => {
    const apiError = categorizeError(error);

    if (apiError.statusCode === 401 && onUnauthorized) {
      onUnauthorized();
    }

    return Promise.reject(apiError);
  }
);

export default apiClient;
